import {Injectable} from '@angular/core';
import {Actions, Effect} from '@ngrx/effects';
import {Observable} from 'rxjs/Observable';
import {Action, Store} from '@ngrx/store';
import 'rxjs/add/operator/withLatestFrom';
import 'rxjs/add/operator/map';
import * as formEditorActions from './form-editor.actions';
import {FormService} from '../services/form.service';
import {AppState} from '../../reducers/index';


@Injectable()
export class FormEditorEffects {
    @Effect()
    build: Observable<Action> = this.actions.ofType(formEditorActions.BUILD_FORM)
        .withLatestFrom(this.state)
        // .do(console.log)
        .filter(arr => arr[1].forms.formEditor.formStatus)
        .switchMap(arr => this.formService.valueToForm(arr[1].forms.formEditor.formValue))
        .map(form => new formEditorActions.BuildFormSuccess(form));

    @Effect()
    buildFail: Observable<Action> = this.actions.ofType(formEditorActions.BUILD_FORM)
        .withLatestFrom(this.state)
        .filter(arr => !arr[1].forms.formEditor.formStatus)
        .map(() => new formEditorActions.BuildFormFaild('Formulario no válido'));

    @Effect()
    buildOnSubmit: Observable<Action> = this.actions.ofType(formEditorActions.RESET_FORM)
        .withLatestFrom(this.state)
        .filter(arr => !arr[1].forms.formEditor.updated === false)
        .map(() => new formEditorActions.BuildForm());

    constructor(
        private actions: Actions,
        private formService: FormService,
        private state: Store<AppState>
    ) { }
}



// WEBPACK FOOTER //
// ./src/app/forms/state/form-editor.effects.ts